import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=4b87c168&scoped=true&"
var script = {}
import style0 from "./Modal.vue?vue&type=style&index=0&id=4b87c168&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b87c168",
  null
  
)

export default component.exports